module.exports = __webpack_public_path__ + "static/media/hippo final.35f18fe9.jpg";